import { BlocksContent } from '@strapi/blocks-react-renderer'
import { RichTextProps } from 'src/components/RichText'
import { Configuration } from 'src/rest/types/Configuration'
import RegexParser from 'regex-parser'

export function RichTextTransformer(
  text: string | BlocksContent,
  configuration: Configuration,
  locale: string
): RichTextProps {
  return {
    ...(typeof text !== 'string' && {
      jsonContent: text,
    }),
    ...(typeof text === 'string' && {
      html: text,
    }),
    lexicon: {
      pattern: RegexParser(configuration.regex),
      baseUrl: `${locale === 'fr' ? '' : `/${locale}`}/lexique`,
    },
  }
}
